import React from 'react';
import { CellContext } from '@tanstack/react-table';
import { Checkbox } from 'antd';

export function FileExplorerCkeckbox<TData>({
  row,
}: CellContext<TData, unknown>) {
  return (
    <Checkbox
      checked={row.getIsSelected()}
      onChange={(e) => row.getToggleSelectedHandler()(e)}
      disabled={!row.getCanSelect()}
    />
  );
}
